import type { CSSProperties } from 'react';

interface MediaRangeStyle extends CSSProperties {
  '--range-fill': string;
}

export const mediaRangeFillStyle = (percent: number): MediaRangeStyle => {
  const filled = Math.min(100, Math.max(0, percent));
  return { '--range-fill': `${filled}%` };
};
